import { createAction } from 'redux-actions';
import * as types from './parts-constants';

export const searchPartRequest = createAction(types.SEARCH_PART_REQUEST);
export const searchPartSuccess = createAction(types.SEARCH_PART_SUCCESS);
export const searchPartFailure = createAction(types.SEARCH_PART_FAILURE);

export const addPartRequest = createAction(types.ADD_PART_REQUEST);
export const addPartSuccess = createAction(types.ADD_PART_SUCCESS);
export const addPartFailure = createAction(types.ADD_PART_FAILURE);

export const addSupersededPart = createAction(types.ADD_SUPERSEDED_PART);
export const successfullyAddedSupersededPart =
  createAction(types.SUCCESSFULLY_ADDED_SUPERSEDED_PART);

export const getLogisticsDatesRequest = createAction(types.GET_LOGISTICS_DATES_REQUEST);
export const getLogisticsDatesSuccess = createAction(types.GET_LOGISTICS_DATES_SUCCESS);
export const getLogisticsDatesFailure = createAction(types.GET_LOGISTICS_DATES_FAILURE);

export const updateUrgency = createAction(types.UPDATE_URGENCY);
export const updateConsolidation = createAction(types.UPDATE_CONSOLIDATION);
